export const radius = {
  control: '8px',
  panel: '12px',
  dialog: '16px',
  pill: '999px',
} as const;

export type RadiusRole = keyof typeof radius;
